export * from './timeline.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/common/timeline/index.js
// module id = ../../../../@swimlane/ngx-charts/release/common/timeline/index.js
// module chunks = 4